import { render, staticRenderFns } from "./BlogDetailsPage.vue?vue&type=template&id=4422af99&"
import script from "./BlogDetailsPage.vue?vue&type=script&lang=js&"
export * from "./BlogDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports